import { useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const useAutoLogout = () => {
  const API_BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const logoutAfterInactivity = 20 * 60 * 1000; // 5 minutes in milliseconds
  let inactivityTimeout;

  const handleLogout = async () => {
    const authCode = sessionStorage.getItem("auth_code"); // Assuming auth_code is stored in sessionStorage
    if (!authCode) {
      toast.error("You are not logged in.");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/User/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ auth_code: authCode }), // Send auth_code to the backend
      });

      const data = await response.json();

      if (data.status === "Success") {
        sessionStorage.removeItem("auth_code");
        sessionStorage.removeItem("user_id");
        toast.success("Logged out successfully.");
        navigate("/");
      } else {
        toast.error("Logout failed. Please try again.");
      }
    } catch (error) {
      console.error("Error logging out:", error);
      toast.error("Error logging out. Please try again.");
    }
  };

  const resetInactivityTimer = () => {
    clearTimeout(inactivityTimeout);
    inactivityTimeout = setTimeout(handleLogout, logoutAfterInactivity);
  };
  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((event) => {
      window.addEventListener(event, resetInactivityTimer);
    });
    resetInactivityTimer();

    // Clean up the event listeners and timeout on component unmount
    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetInactivityTimer);
      });
      clearTimeout(inactivityTimeout); // Clean up the timer on unmount
    };
  }, []);

  return handleLogout;
};

export default useAutoLogout;
